module.exports = __webpack_public_path__ + "img/shiny.6932c1d2.svg";